import { parseISO, format } from "date-fns";

/** Convert ISO date strings */
export class IsoDateFormatter {
    /** Long date-only with day: Thursday, January 1, 1999 */
    static LongestDate(date) {
        let converted = date;
        if (typeof date === "string") converted = parseISO(date);
        return converted.toLocaleDateString("en-us", { weekday: "long", month: "long", day: "numeric", year: "numeric" });
    }

    /** Long date-only: January 1, 1999 */
    static LongDate(date) {
        let converted = date;
        if (typeof date === "string") converted = parseISO(date);
        return converted.toLocaleDateString("en-us", { month: "long", day: "numeric", year: "numeric" });
    }

    /** Shortest date-only: 3/5 */
    static ShortestDate(date) {
        let converted = date;
        if (typeof date === "string") converted = parseISO(date);
        return converted.toLocaleDateString("en-us", { month: "numeric", day: "numeric" });
    }

    /** ISO-similar date-only: 1999-01-02 */
    static DateOnly(date) {
        let converted = date;
        if (typeof date === "string") converted = parseISO(date);
        return format(converted, "yyyy-MM-dd");
    }

    /** ISO-similar date for admin pages */
    static AdminDate(date) {
        let converted = date;
        if (date === null || date === undefined || date === "") return "";
        if (typeof date === "string") converted = parseISO(date);
        return format(converted, "yyyy-MM-dd HH:mm:ss");
    }

    /** Shortest day-only: 3 */
    static ShortestDay(date) {
        let converted = date;
        if (typeof date === "string") converted = parseISO(date);
        return converted.toLocaleDateString("en-us", { day: "numeric" });
    }

    /** 3 char month: Mar */
    static ShortMonth(date) {
        let converted = date;
        if (typeof date === "string") converted = parseISO(date);
        return converted.toLocaleDateString("en-us", { month: "short" });
    }

    /** 3 char weekday: Wed */
    static ShortWeekday(date) {
        let converted = date;
        if (typeof date === "string") converted = parseISO(date);
        return converted.toLocaleDateString("en-us", { weekday: "short" });
    }

    /** Full weekday: Wednesday */
    static LongWeekday(date) {
        let converted = date;
        if (typeof date === "string") converted = parseISO(date);
        return converted.toLocaleDateString("en-us", { weekday: "long" });
    }

    /** Long month, year: March 2023 */
    static LongMonthYear(date) {
        let converted = date;
        if (typeof date === "string") converted = parseISO(date);
        return converted.toLocaleDateString("en-us", { month: "long", year: "numeric" });
    }
}

/**
 *  Returns true if a date is in the past (ignoring time)
 */
export function IsDateInPast(date) {
    let converted = date;
    if (typeof date === "string") converted = parseISO(date);
    const today = new Date();
    // Remove time part
    today.setHours(0, 0, 0, 0);
    return converted < today;
}

export function AreMonthsEqual(date1, date2) {
    let converted1 = date1
    let converted2 = date2;
    if (typeof date1 === "string") converted1 = parseISO(date1);
    if (typeof date2 === "string") converted2 = parseISO(date2);
    return converted1.getFullYear() === converted2.getFullYear() && converted1.getMonth() === converted2.getMonth();
}
